declare var swal: any;
import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

import { NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateParserFormatter, NgbTimeStruct } from '@ng-bootstrap/ng-bootstrap';




@Component({
    selector: 'auto-section-1pv',
    templateUrl: './autosection1pv.component.html',
    styleUrls: ['./autosection1pv.component.scss']
})

export class AutoSection1PVComponent implements OnInit {
    ngOnInit(): void {
       
    }
}
